import { useEffect, useState } from 'react';
import { ArrowRight, Star } from 'lucide-react';

const BALLOT = 'https://bit.ly/4AJgYbv';

/** Front-page call to vote in the Red Hook Stars awards. Disappears after voting closes Nov 10, 2026. */
export function StarsBanner() {
  const [open, setOpen] = useState(true);
  useEffect(() => { setOpen(new Date() < new Date(2026, 10, 11)); }, []);
  if (!open) return null;
  return (
    <a href={BALLOT} target="_blank" rel="noopener noreferrer" aria-label="Vote in the Red Hook Stars Community Appreciation Awards (opens the ballot)"
      className="group mx-auto mt-6 block max-w-6xl px-4">
      <div className="flex flex-col gap-4 border-2 border-foreground bg-[hsl(var(--banner-blue))] p-5 text-[hsl(var(--brand-brown-foreground))] shadow-[6px_6px_0_hsl(var(--muted-foreground)/0.35)] transition-transform group-hover:-translate-y-0.5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
        <div className="flex items-start gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center border-2 border-foreground bg-[hsl(var(--brand-yellow))] text-foreground">
            <Star className="h-8 w-8 fill-current" />
          </div>
          <div className="min-w-0">
            <div className="text-[11px] font-bold uppercase tracking-[0.2em] opacity-90">Vote now · closes November 10</div>
            <div className="font-[family-name:var(--font-heading)] text-2xl font-black leading-tight tracking-tight sm:text-3xl"><span className="uppercase">Red Hook Stars</span> Community Appreciation Awards</div>
            <p className="mt-1 text-sm opacity-90">Best pizza, best bar, best bodega, best vet and 26 more. Tell us who makes Red Hook great.</p>
          </div>
        </div>
        <span className="inline-flex min-h-12 shrink-0 items-center justify-center gap-2 border-2 border-foreground bg-[hsl(var(--brand-yellow))] px-5 text-base font-bold text-foreground shadow-[3px_3px_0_hsl(var(--foreground))]">
          Cast your vote <ArrowRight className="h-5 w-5" strokeWidth={3} />
        </span>
      </div>
    </a>
  );
}
